import request from "../../utils/request";
import {
    CalculateEndOfServiceInput,
    EndOfServiceDetailsInput,
    EndOfServiceDetailsView,
    EndOfServiceTypeInput,
    EndOfServiceTypeView,
    FinalSettelmentInput,
    FinalSettelmentView,
    UserEndOfServiceView,
    EosContextView,
    EosBreakdownView,
    SettlementBreakdownView,
    PreviewEosInput,
    PreviewSettlementInput,
    EosAuditLogEntry,
    ReopenSettlementInput,
    MarkSettlementPaidInput,
    SettlementAuditLogEntry,
} from "../../models/payroll";
import {  Result } from "../../models/general";


export async function GetEndOfServiceTypes() {
    const response = await request.get<Result<EndOfServiceTypeView[]>>("Payroll/GetEndOfServiceTypes");
    return response.data;
}
export async function AddEndOfServiceType(input : EndOfServiceTypeInput) {
    const response = await request.post<Result<EndOfServiceTypeView>>("Payroll/AddEndOfServiceType",input);
    return response.data;
}
export async function GetEndOfServiceDetailsByEOSId(typeId : number) {
    const response = await request.get<Result<EndOfServiceDetailsView[]>>(`Payroll/GetEndOfServiceDetails/${typeId}`);
    return response.data;
}
export async function GetEndOfServiceDetails() {
    const response = await request.get<Result<EndOfServiceDetailsView[]>>(`Payroll/GetEndOfServiceDetails`);
    return response.data;
}
export async function GetEndOfServiceDetailsById(Id : number) {
    const response = await request.get<Result<EndOfServiceDetailsView[]>>(`Payroll/GetEndOfServiceDetailsById/${Id}`);
    return response.data;
}
export async function AddEndOfServiceDetail(input : EndOfServiceDetailsInput) {
    const response = await request.post<Result<EndOfServiceDetailsView>>("Payroll/AddEndOfServiceDetail",input);
    return response.data;
}
export async function UpdateEOSDetail(input : EndOfServiceDetailsInput, id: number) {
    const response = await request.post<Result<EndOfServiceDetailsView>>(`Payroll/UpdateEOSDetail/${id}`,input);
    return response.data;
}
export async function CalculateEndOfService(input : CalculateEndOfServiceInput) {
    const response = await request.post<Result<UserEndOfServiceView>>("Payroll/CalculateEndOfService",input);
    return response.data;
}
export async function SetEndOfService(input : CalculateEndOfServiceInput) {
    const response = await request.post<Result<boolean>>("Payroll/SetEndOfService",input);
    return response.data;
}

export async function FinalSettlementCalculation(input : FinalSettelmentInput){
    const response=await request.post<Result<FinalSettelmentView>>(`Payroll/FinalSettlementCalculation/`, input);
    return response.data;
}
export async function SetFinalSettlement(input : FinalSettelmentInput){
    const response=await request.post<Result<boolean>>(`Payroll/SetFinalSettlement/`, input);
    return response.data;
}
export async function GetFinalSettlement(userId : string){
    const response=await request.get<Result<FinalSettelmentView>>(`Payroll/GetFinalSettlement/${userId}`);
    return response.data;
}
export async function GetEndOfService(userId : string){
    const response=await request.get<Result<UserEndOfServiceView>>(`Payroll/GetEndOfService/${userId}`);
    return response.data;
}
export async function RemoveFinalSettlement(userId : string){
    const response=await request.post<Result<FinalSettelmentView>>(`Payroll/RemoveFinalSettlement/${userId}`);
    return response.data;
}
export async function RemoveEndOfService(userId : string){
    const response=await request.post<Result<UserEndOfServiceView>>(`Payroll/RemoveEndOfService/${userId}`);
    return response.data;
}

// EOS Compliance endpoints
export async function GetEosContext(userId: string) {
    const response = await request.get<Result<EosContextView>>(`EosCompliance/Context/${userId}`);
    return response.data;
}
export async function PreviewEndOfService(input: PreviewEosInput) {
    const response = await request.post<Result<EosBreakdownView>>("EosCompliance/PreviewEos", input);
    return response.data;
}
export async function ConfirmEndOfService(input: PreviewEosInput) {
    const response = await request.post<Result<UserEndOfServiceView>>("EosCompliance/ConfirmEos", input);
    return response.data;
}
export async function PreviewSettlement(input: PreviewSettlementInput) {
    const response = await request.post<Result<SettlementBreakdownView>>("EosCompliance/PreviewSettlement", input);
    return response.data;
}
export async function ConfirmFinalSettlement(input: PreviewSettlementInput) {
    const response = await request.post<Result<boolean>>("EosCompliance/ConfirmSettlement", input);
    return response.data;
}
export async function GetEosAuditLog(userId: string) {
    const response = await request.get<Result<EosAuditLogEntry[]>>(`EosCompliance/AuditLog/${userId}`);
    return response.data;
}

// Settlement lifecycle (B3) + audit trail (B8b)
export async function reopenSettlement(input: ReopenSettlementInput) {
    const response = await request.post<Result<boolean>>("EosCompliance/ReopenSettlement", input);
    return response.data;
}
export async function markSettlementPaid(input: MarkSettlementPaidInput) {
    const response = await request.post<Result<boolean>>("EosCompliance/MarkSettlementPaid", input);
    return response.data;
}
export async function getSettlementAuditLog(userId: string) {
    const response = await request.get<Result<SettlementAuditLogEntry[]>>(`EosCompliance/SettlementAuditLog/${userId}`);
    return response.data;
}
